import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../../context/LanguageContext';
import { PROCESS } from '../../content/site';
import { EASE } from '../ui/Primitives';
export function ProcessSteps({
  tone = 'light'
}: {
  tone?: 'light' | 'dark';
}) {
  const {
    language
  } = useLanguage();
  const t = PROCESS[language];
  const titleColor = tone === 'light' ? 'text-espresso' : 'text-pearl';
  const bodyColor = tone === 'light' ? 'text-espresso/60' : 'text-pearl/60';
  const numColor = tone === 'light' ? 'text-bronze' : 'text-bronze';
  const ruleColor = tone === 'light' ? 'bg-espresso/12' : 'bg-pearl/15';
  return <div className="grid gap-12 sm:grid-cols-2 lg:grid-cols-4 lg:gap-10" data-id="element-88" data-mp="1nonp7jdvqsid">
      {t.steps.map((step, index) => <motion.div key={step.number} initial={{
      opacity: 0,
      y: 24
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-60px'
    }} transition={{
      duration: 0.65,
      delay: index * 0.1,
      ease: EASE
    }} data-id="element-89" data-mp="1smfiagq9gko5" data-mpi={index}>
          <div className="mb-6 flex items-center gap-4" data-id="element-90" data-mp="9bcc1gjrsx49">
            <span className={`font-serif text-3xl font-light italic leading-none ${numColor}`} data-id="element-91" data-mp="4bpyf6015eux">
              {step.number}
            </span>
            <span className={`h-px flex-1 ${ruleColor}`} aria-hidden="true" data-id="element-92" data-mp="i94rqltem6s6" />
          </div>
          <h3 className={`mb-3 font-serif text-xl font-normal leading-snug ${titleColor}`} data-id="element-93" data-mp="datjgfirc4c2">
            {step.title}
          </h3>
          <p className={`text-sm font-light leading-relaxed ${bodyColor}`} data-id="element-94" data-mp="nb3wo04slbr8">
            {step.description}
          </p>
        </motion.div>)}
    </div>;
}